import gql from 'graphql-tag'

import { ITour, ITourQueryWhereUniqueInput } from './common';

export const TourFragment = gql`
	fragment TourFragment on Tour {
        id
        title
        description
        slug
        lat
        lng
        country {
            id
            title
            slug
            continentName
        }
        location {
            id
            region
            regionSlug
            city
            citySlug
        }
	}
`

export const TourQuery = gql`
	query tour($where: TourWhereUniqueInput!) {
		tour(where: $where) {
			...TourFragment
		}
	}
	${TourFragment}
`

export interface ITourQueryVariables {
    where: ITourQueryWhereUniqueInput
}

export interface ITourQueryData {
    tour: ITour
}